import { COMMUNITIES_APIS } from "libs/apis/communities.api";
import { USER_APIS } from "libs/apis/users.api";

const useCommunities = () => {
  const getCommunities = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await COMMUNITIES_APIS.getCommunities(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      if (setFilters) {
        setFilters((prev: any) => ({
          ...prev,
          limit: pageSize,
        }));
      }
      if (setTotalElements) {
        setTotalElements(totalElements);
      }
    } else {
      setData([]);
      if (setTotalElements) {
        setTotalElements(0);
      }
    }
  };

  const getUserById = async (userId: number, setData: Function) => {
    const response = await USER_APIS.getUserById(userId);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data);
    }
  };

  return {
    getCommunities,
    getUserById,
  };
};

export default useCommunities;
